/**
 * 将所有node_modules中组件迁移到项目内，统一为请求添加公用的UserAgent
 * @author zhenn
 * @createTime 2017-10-24
 */

const proxyUrl = {
    pro: '//proxy.upliveapps.com/index/index',
    dev: '//awsbj-proxy.xingyunzhi.cn/index/index',
    stage: '//sg-stage-proxy.upliveapp.com/index/index'
};

const noop = () => {
};

const timeout = 5000;

class PbAajx {

    constructor() {
        this.canceled = 0;
    }

    // canceled: 0, // 是否被取消

    do(cfg, data, success = noop, timeoutFn = noop, fail = noop, respType = 'arraybuffer') {
        let prefix = proxyUrl[this.env()];

        if (!cfg.header) {
            cfg.header = {};
        }

        cfg.header.UserAgent = UG.getGlobalUA();

        let _url = prefix + '?' + $.param(cfg);
        let timer, xhr;
        timer = setTimeout(function () {
            timeoutFn();
        }, timeout);

        try {
            xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
            xhr.timeout = timeout;
            xhr.open('POST', _url, true);
            if (respType === 'arraybuffer') {
                xhr.responseType = respType;
            }
            try {
                xhr.send(respType === 'arraybuffer' ? data.toArrayBuffer() : data);
            } catch (e) {
                xhr.send();
            }
        } catch (e) {
            console.log(e);
            UG.simple(UG.lang.template('Current browser doesn\'t support ajax，please upgrade your browser to a newer version'));
        }

        xhr.onreadystatechange = (data) => {

            if (xhr.readyState === 4) {
                clearTimeout(timer);
                if (xhr.status === 200) {
                    if (!this.canceled) {
                        success(xhr.response);
                    }

                } else {
                    if (typeof fail === 'function') {
                        fail();
                    }
                }
            }
        };

    }

    query(name, scope = 'search') {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i'),
            r = location[scope].substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    env() {
        return this.query('env') || 'pro';
    }

    serializeURI(obj) {
        var result = [];
        if (typeof obj !== 'object') {
            obj = {};
        }
        for (var i in obj) {
            result.push(i + '=' + encodeURIComponent(obj[i]));
        }

        return result.join('&');
    }

    cancel() {
        this.canceled = 1;
    }
}

export default PbAajx;



// WEBPACK FOOTER //
// ./js/component/c-up-pbajax/index.js